export function useOnClick(props) {
  return function onClick() {
    if (props.scrollContainerRef?.current) {
      props.scrollContainerRef.current.scrollTo({
        left: 0,
        behavior: 'smooth',
      })
    }
  }
}
